import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountPurchases';

const AccountPurchasesSuspense = dynamic(() => import('./AccountPurchases'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicAccountPurchases(props: Props) {
	return <AccountPurchasesSuspense {...props} />;
}
DynamicAccountPurchases.displayName = 'DynamicAccountPurchases';
